import { useAppDispatch, useAppSelector } from '@/Hook/hooks'
import { getDataAnalyticsConfig } from '@/Redux/Ducks/dataAnalyticsSlice'
import { getScreenConfig } from '@/Redux/Ducks/entryFormSlice'
import { toggleDesignMode } from '@/Redux/Ducks/homeSlice'
import { toggleLoader } from '@/Redux/Ducks/loaderSlice'
import { getReportConfig } from '@/Redux/Ducks/reportExplorerSlice'
import { logoutUser } from '@/Redux/Ducks/userSlice'
import { requestRefreshApplication } from '@/Redux/Sagas/Requests/user'
import { API_URL } from '@/Utils/constants'
import BaseMethods from 'AlignBaseUI/BaseMethods'
import { ControlTranslation, Modal } from 'AlignComponents'
import QRCode from 'qrcode.react'
import { useState } from 'react'
import { Form, NavDropdown } from 'react-bootstrap'
import { AiOutlineScan } from 'react-icons/ai'
import { FaQrcode, FaSearch, FaSignOutAlt, FaSync, FaUserCog } from 'react-icons/fa'
import { useHistory } from 'react-router'

const UserDropdown = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [isQRCodeModalOpen, toggleQRCodeModal] = useState<boolean>(false);

  const getApiUrl = () => {
    if (API_URL?.includes("https") || API_URL?.includes("http"))
      return API_URL
    else
      return window.location.origin + API_URL?.substring(1)
  }

  const { userFullName, userphoto, useremail, allowMobile, qrCodeValue, designMode } = useAppSelector((state) => ({
    userFullName: state.User.user.name?.split(' ').map(x => x.charAt(0).toUpperCase() + x.slice(1)).join(' '),
    userphoto: state.User.user.userphoto,
    useremail: state.User.user.email,
    allowMobile: state.User.user.allowmobile,
    qrCodeValue: JSON.stringify({
      authToken: state.User.authToken,
      apiUrl: getApiUrl()
    }),
    designMode: state.Home.designMode
  }));

  const refreshApplicationFunc = async () => {
    try {
      dispatch(toggleLoader(true));
      await requestRefreshApplication();
      location.reload();
    }
    catch (ex) {
    }
    finally {
      dispatch(toggleLoader(false));
    }
  };

  const logoutFunc = () => {
    history.push("/");
    setTimeout(() => {
      dispatch(logoutUser());
    }, 10);
  };

  const routeToDocumentation = () => {
    const docUrl = 'http://businessflo.alignbsystem.com/documentation/';
    window.open(docUrl, '_blank')?.focus();
  }

  const routeToObject = (objectcontrollerno: string, objecttype: string) => {
    switch (objecttype) {
      case "E":
        dispatch(getScreenConfig({ processCode: objectcontrollerno }))
        break;
      case "I":
        dispatch(getDataAnalyticsConfig({ dataAnalyticsno: objectcontrollerno }))
        break;
      case "R":
        dispatch(getReportConfig({ reportObjectno: objectcontrollerno }))
        break;
    }
  }

  const userDropdown = (
    <img src={BaseMethods.getUserPhoto(userphoto)} alt="User" />
  );

  const openQRCodeModal = () => {
    toggleQRCodeModal(true);
  }

  const closeQRCodeModal = () => {
    toggleQRCodeModal(false);
  }

  const handleToggleDesignMode = (e: any) => {
    dispatch(toggleDesignMode(e.target.checked));
  }

  return (
    <>
      <Modal
        close={closeQRCodeModal}
        heading={
          <div className="qr-code-header">
            <div className="qr-code-icon">
              <AiOutlineScan size={40} color="#fff" />
            </div>
            <div className="qr-code-text">
              <h3>
                <ControlTranslation system={true} controlId="lblscan" />
              </h3>
              <p>
                <ControlTranslation system={true} controlId="lblscantext" />
              </p>
            </div>
          </div>
        }
        show={isQRCodeModalOpen}
        modalDialogStyle={{ textAlign: 'center', maxWidth: '350px' }}
        backdropStyle={{ opacity: "0.1" }}
        modalSize="sm"
        className="qr-code-modal"
      >
        <>
          <div className="qr-code-container">
            <QRCode value={qrCodeValue} size={200} />
            {/* <img src={require("@/Assets/Images/logo-light.png").default} alt="Logo" className="qr-code-logo" /> */}
          </div>
        </>
      </Modal>
      <NavDropdown title={userDropdown} >
        <div className="user-section">
          <img src={BaseMethods.getUserPhoto(userphoto)} alt="" className="rounded-circle thumb-md" />
          <div className="user-text">
            <h6>{userFullName}</h6>
            <span>{useremail}</span>
          </div>
        </div>
        <NavDropdown.Divider />
        <NavDropdown.Item role="button" onClick={() => { routeToObject("OSLE", "E") }}>
          <FaUserCog size={14} className="me-2" />
          <ControlTranslation system={true} controlId="lblusersettings" />
        </NavDropdown.Item>
        {
          allowMobile ? (
            <NavDropdown.Item role="button" onClick={openQRCodeModal}>
              <FaQrcode size={14} className="me-2" />
              <ControlTranslation system={true} controlId="btnlinkdevice" />
            </NavDropdown.Item>
          ) : null
        }
        <NavDropdown.Item role="button" onClick={refreshApplicationFunc}>
          <FaSync size={14} className="me-2" />
          <ControlTranslation system={true} controlId="btnrefreshapplication" />
        </NavDropdown.Item>
        <NavDropdown.Item role="button" onClick={routeToDocumentation}>
          <FaSearch size={14} className="me-2" />
          <ControlTranslation system={true} controlId="btndocumentation" />
        </NavDropdown.Item>
        <NavDropdown.Item role="button" onClick={logoutFunc}>
          <FaSignOutAlt size={14} className="me-2" />
          <ControlTranslation system={true} controlId="btnlogout" />
        </NavDropdown.Item>
        <NavDropdown.Divider />
        <NavDropdown.ItemText role="button">
          <Form.Check
            type="switch"
            checked={designMode}
            onChange={handleToggleDesignMode}
            reverse={true}
            label={
              <ControlTranslation system={true} controlId="lblenabledesignermode" />
            }
          />
        </NavDropdown.ItemText>
      </NavDropdown>
    </>
  )
}

export default UserDropdown